import { IStackStyles, Stack, Pivot, PivotItem } from '@fluentui/react';
import { useContext, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AppContext from '../AppContext';
import Groups from './Groups';
import Users from './Users';
import Tenants from './Tenants';
import PermissionsV2 from './PermissionsV2';
import { ActivityLogList } from './ActivityLogList';
import AccessRulesList from './AccessRulesList';

const Security = () => {
  const { t } = useTranslation();
  const context = useContext(AppContext);
  const query = new URLSearchParams(useLocation().search);
  const navigate = useNavigate();

  const tabs = useMemo(
    () => [
      { key: 'users', header: 'Users', render: () => <Users /> },
      { key: 'groups', header: 'Groups', render: () => <Groups /> },
      {
        key: 'workAccesses',
        header: 'Work accesses',
        render: () => <AccessRulesList entity="Work" />,
      },
      {
        key: 'orderAccesses',
        header: 'Order accesses',
        render: () => <AccessRulesList entity="Order" />,
      },
      {
        key: 'permissions',
        header: 'Permissions',
        render: () => <PermissionsV2 />,
      },
      { key: 'tenants', header: t('tenants'), render: () => <Tenants /> },
      {
        key: 'activities',
        header: 'Activities',
        render: () => <ActivityLogList />,
      },
    ],
    [t]
  );

  const selectedKey = query.get('tab') ?? tabs[0].key;
  const selectedHeader =
    tabs.find((x) => x.key === selectedKey)?.header ?? tabs[0].header;

  const { setSelectedTab } = context;
  useEffect(() => {
    setSelectedTab(selectedHeader);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedHeader]);

  const stackStyles: IStackStyles = {
    root: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
      label: {
        display: 'flex',
        paddingLeft: 10,
      },
    },
  };

  return (
    <Stack styles={stackStyles}>
      <Pivot
        styles={{ root: { width: '100%' }, itemContainer: { width: '100%' } }}
        selectedKey={selectedKey}
        onLinkClick={(item) => {
          const key = item?.props.itemKey;
          if (key === 'back') {
            navigate('/');
            return;
          }
          if (key) navigate(`/security?tab=${key}`);
        }}
      >
        <PivotItem itemIcon="ChromeBack" itemKey="back" />
        {tabs.map((tabDef) => (
          <PivotItem
            key={tabDef.key}
            headerText={tabDef.header}
            itemKey={tabDef.key}
          >
            {tabDef.render()}
          </PivotItem>
        ))}
      </Pivot>
    </Stack>
  );
};

export default Security;
